import { LoginService } from 'app/login/login.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// External
import { ModalModule } from 'ngx-bootstrap/modal';

// CF Design

// Shared
import { NewLoginWidgetComponent } from './new-login-widget.component' //from './login.component';
import { SharedModule } from '@mem-shared/shared.module';
import { TabsModule } from '@mem-shared/tabs/tabs.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { AccountLockedComponent } from ''//'./../account-locked/account-locked.component';
// import { KeepAccountSafeComponent } from './keep-account-safe/keep-account-safe.component';
// import { KeepAccountSafeStep2Component } from './keep-account-safe-step2/keep-account-safe-step2.component';
import { TextMaskModule } from 'angular2-text-mask';
// import { LoginService } from '../login/login.service';//'./login.service';
import { TouchFaceIdService } from '@mem-shared/touchFaceId.service';
import { RegistrationService } from '../new-registration/registration.service';
 import { WelcomeEmailService } from 'app/welcome-email/welcome-email.service';
import { MapdnativeAppMsgComponent } from './mapdnative-app-msg/mapdnative-app-msg.component';
import { NewLoginWidgetRoutingModule } from './new-login-widget-routing.module';
import { NewLoginWidgetService } from './new-login-widget.service';
import { NewLoginSeviceService } from '../new-login/new-login.service';
import { LogoutComponent } from './logout/logout.component';
import { NotSupportedAccountAppMsgComponent } from './notsupportedaccount-app-msg/notsupportedaccount-app-msg.component';
import { NewLoginWidgetHeaderComponent } from './new-login-widget-header/new-login-widget-header.component';
import { NewLoginWidgetFooterComponent } from './new-login-widget-footer/new-login-widget-footer.component';
import { NewLoginWidgetSuccessComponent } from './new-login-widget-success/new-login-widget-success.component';
import { LogoutredirectComponent } from './logoutredirect/logoutredirect.component';
import { NewloginLoaderComponent } from '../new-login/newlogin-loader/newlogin-loader.component';

// import { LoginModule } from 'app/login/login.module';
// import { KeepAccountSafeStep3Component } from './keep-account-safe-step3/keep-account-safe-step3.component';
// import { LogoutComponent } from 'app/login/logout/logout.component';
// import { KeepAccountSafeUtilService } from 'app/new-login/keep-account-safe-util.service';


@NgModule({
  imports: [
    CommonModule, SharedModule,
    NewLoginWidgetRoutingModule,
    // LoginModule,
    FormsModule, ReactiveFormsModule,
    TabsModule, ModalModule, TextMaskModule
  ],
  declarations: [
    NewLoginWidgetComponent,
    MapdnativeAppMsgComponent,
    NotSupportedAccountAppMsgComponent,
    LogoutComponent,
    NewLoginWidgetHeaderComponent,
    NewLoginWidgetFooterComponent,
    NewLoginWidgetSuccessComponent,
    LogoutredirectComponent,
    NewloginLoaderComponent,
    //  AccountLockedComponent,
    //  KeepAccountSafeComponent,
    //  KeepAccountSafeStep2Component,
    //  KeepAccountSafeStep3Component,
    //  NewloginLoaderComponent,
  ],
  exports: [
    NewLoginWidgetComponent,
  ],
  providers: [
    TouchFaceIdService,
    NewLoginWidgetService,
    LoginService,
    RegistrationService,
    WelcomeEmailService,
    NewLoginSeviceService
  ]
})
export class NewLoginWidgetModule { }



// WEBPACK FOOTER //
// ./src/app/new-login-widget/new-login-widget.module.ts